/**
 * Formatage des prix du Catalog — adaptateur de vocabulaire sur
 * `@odys/format/price`, qui porte désormais la logique (issue #2515).
 *
 * La règle métier (symbole avant le montant en anglais, après ailleurs) a été
 * promue depuis ce fichier : c'était la seule des douze implémentations du
 * monorepo à l'écrire. Ne subsiste ici que la signature positionnelle attendue
 * par les appelants du Catalog.
 */

import { formatPrice as formatPriceShared } from '@odys/format/price';

import type { FormatPriceOptions as SharedOptions } from '@odys/format/price';

export { ceilAmount, currencyAdornment, displayableAmount } from '@odys/format/price';

type FormatPriceOptions = Pick<SharedOptions, 'minimumFractionDigits' | 'maximumFractionDigits'>;

export function formatPrice(
    amount: number | null,
    currency: string | null,
    locale: string,
    options: FormatPriceOptions = {},
): string {
    return formatPriceShared(amount, { locale, currency, ...options });
}
